/********************************************************************************************                              
* Module Name           : app.js
* Author                : Ricky Nguyen  
* Date Created          : 2025-02-09 00:31:49                                    
* Description           : This file is the entry point for webpack compiler for JS files.          
*                                                     
*                                COPYRIGHT 2025 | ANACA
*********************************************************************************************/
import * as calendly from "./calendly/calendly-feature";
import * as frmAction from "./form-action/change-start-course-form-action";
import * as pgPricingUI from "./page-pricing/pricing-page-ui";


